import { z } from 'zod';

import type {
  UpdateScaleTicketRequest,
  UpdateScaleTicketResponse,
} from './update-scale-ticket.dto.js';
import {
  ShipmentScaleTicketSchema,
} from './shipments-shared.schema.js';

export const validateScaleTicketUpdateFields = (value: unknown, ctx: z.RefinementCtx): void => {
  if (!value || typeof value !== 'object') {
    return;
  }
  const tareWeightLb = (value as { tareWeightLb?: number | null }).tareWeightLb;
  const notes = (value as { notes?: string | null }).notes;
  const photoUrl = (value as { photoUrl?: string | null }).photoUrl;
  if (tareWeightLb === undefined && notes === undefined && photoUrl === undefined) {
    ctx.addIssue({
      code: 'custom',
      message: 'Provide tareWeightLb, notes, or photoUrl.',
      path: ['tareWeightLb'],
    });
  }
};

export const UpdateScaleTicketRequestSchema: z.ZodType<UpdateScaleTicketRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    scaleTicketId: z.uuid(),
    tareWeightLb: z.number().min(0).nullable().optional(),
    notes: z.string().trim().min(1).nullable().optional(),
    photoUrl: z.string().trim().min(1).nullable().optional(),
  })
  .strict()
  .superRefine(validateScaleTicketUpdateFields);

export const UpdateScaleTicketResponseSchema: z.ZodType<UpdateScaleTicketResponse> = z
  .object({
    scaleTicket: ShipmentScaleTicketSchema,
  })
  .strict();
